module.exports = __webpack_public_path__ + "img/message-white.49e1a275.svg";